import { render, staticRenderFns } from "./provider-game-detail.vue?vue&type=template&id=9362d3b4&"
import script from "./provider-game-detail.vue?vue&type=script&lang=js&"
export * from "./provider-game-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports